import { useEffect } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { isBrowser } from '../../utils/is-browser';

import { DebugTriggers } from './debug-triggers';

export const useDebugNudgeTriggers = (): void => {
	useEffect(() => {
		if (!isBrowser()) {
			return;
		}

		if (!fg('aix_nudge_recommendation_migration_enabled')) {
			return;
		}

		if (!window?.AIX_DEBUG_NUDGE_TRIGGERS) {
			window.AIX_DEBUG_NUDGE_TRIGGERS = new DebugTriggers();
		}

		return () => {
			if (window.AIX_DEBUG_NUDGE_TRIGGERS) {
				delete window.AIX_DEBUG_NUDGE_TRIGGERS;
			}
		};
	}, []);
};
